import { useBlockProps, InnerBlocks } from '@wordpress/block-editor';
import { getBlockClassNames } from '@components/class-dropdown';

const Save = (props) => {
  const {
    attributes,
    attributes: { blockClassNames },
  } = props;

  const classNames = getBlockClassNames(blockClassNames);
  const blockProps = useBlockProps.save({
    className: `e-lgs ${classNames}`,
  });
  return (
    <div {...blockProps}>
      <InnerBlocks.Content {...attributes} />
    </div>
  );
};

export default Save;
